import { twMerge } from "tailwind-merge";

export const Title = ({ children }: { children: React.ReactNode }) => {
  return <div className="text-[16px] font-medium">{children}</div>;
};

export const Content = ({ className, children }: { className?: string; children: React.ReactNode }) => {
  return <div className={twMerge("rounded-md p-[24px] bg-kds-bg-soft", className)}>{children}</div>;
};

Content.Title = Title;
